export default __webpack_public_path__ + "static/media/edit_white.fb27ed40.svg";